import { MessageResponseDto } from "@api/api";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { utilServiceFormDefault } from "@factory/form/form.default";
import {
  UtilServiceFormRule,
  UtilServiceFormSchema,
} from "@factory/form/form.rule";
import { useQyCreateUtilService } from "@factory/query/util-service.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewUtilService() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateUtilService } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();
  const { getUserRole } = useUserIdentityContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New UtilService is created`);
    navigate(`../`);
  };
  const { mutate: addUtilService, isLoading: isCreating } =
    useQyCreateUtilService(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<UtilServiceFormSchema>({
    defaultValues: utilServiceFormDefault,
    resolver: zodResolver(UtilServiceFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: UtilServiceFormSchema) => {
    const { tenant } = getUserRole();
    const updatedForm = {
      ...form,
      tenant,
    };
    const formData = mapCreateUtilService(updatedForm);
    addUtilService(formData);
  };
  const handleValidateError = (err: FieldErrors<UtilServiceFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
